/// <amd-module name="Pipeline/Analytics/Common/Components/PipelineReportInsights" />
import * as Resources from "Pipeline/Analytics/Common/Resources";
import { ITopFailingStageAndTaskData } from "Pipeline/Analytics/Common/Types";
import { localeFormat } from "VSS/Core/Util/String";

export class PipelineReportInsights {
    
    public _getTopFailingStageAndTaskDisplayName(
        topFailingStageAndTask: ITopFailingStageAndTaskData,
        topFailingTaskPercentage: number | undefined
    ): string {
        if (this._hasStageAndTaskFailures(topFailingStageAndTask)) {
            return localeFormat(
                Resources.TopFailingStageAndTaskLabel,
                "<span style='font-style: italic'>" + topFailingStageAndTask.stageName + "</span>",
                topFailingTaskPercentage + Resources.Percentage,
                "<span style='font-style: italic'>" + topFailingStageAndTask.taskName + "</span>"
            );
        } else if (this._hasTaskFailureWithoutStage(topFailingStageAndTask)) {
            return localeFormat(
                Resources.TopFailingTaskLabel,
                topFailingTaskPercentage + Resources.Percentage,
                "<span style='font-style: italic'>" + topFailingStageAndTask.taskName + "</span>"
            );
        } else {
            return "";
        }
    }

    public _hasTaskFailureWithoutStage(topFailingStageAndTask: ITopFailingStageAndTaskData) {
        return (
            topFailingStageAndTask && !topFailingStageAndTask.stageName && topFailingStageAndTask.taskName && topFailingStageAndTask.stageFailureCount
        );
    }

    public _hasStageAndTaskFailures(topFailingStageAndTask: ITopFailingStageAndTaskData) {
        return topFailingStageAndTask && topFailingStageAndTask.stageName && topFailingStageAndTask.taskName;
    }
}
